import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import { CpdCategoryStatus, cpdCategoryTypeWithLabel } from '../../../../constants';
import { adminActions } from '../../../../state/modules/admin';
import { Icon, SortableTable } from '../../../components';
import Loading from '../../loading';

const cpdCategoryColumns = [
  {
    name: 'name',
    display: () => 'Name',
    className: () => "name",
  },
  {
    name: 'descriptions',
    display: () => 'Descriptions',
    className: () => "descriptions",
  },
  {
    name: 'industry',
    display: () => 'Industry',
    className: () => "industry",
  },
  {
    name: 'type',
    display: () => 'Type',
    className: () => "type",
  },
  {
    name: 'legacy',
    display: () => 'Legacy',
    className: () => 'legacy'
  },
  {
    name: 'edit',
    display: () => 'Edit',
    className: () => "edit",
  }
];

const industryCpdCategoryColumns = [
  {
    name: 'name',
    display: () => 'Name',
    className: () => "name",
  },
  {
    name: 'cpdCategories',
    display: () => 'CPD Categories',
    className: () => "cpdCategories",
  }
];

const AdminCpdCategory = ({
  activeCpdCategoryRows,
  archivedCpdCategoryRows,
  industryCpdCategoryRows
}) => (
    <div className='base-layout'>
      <section className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>CPD Category admin</h1>
            </Col>
          </Row>
        </Grid>
      </section>
      <section id='section--admin-cpd-category' className='layout--section'>
        <Grid>
          <Row className='xs-gutter'>
            <Col xs={12} md={9}>
              <h2><Icon icon='caddie-links-large-alt' /> CPD Categories</h2>
              <p>Add or manage CPD Categories.</p>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer to={routes.adminPortal.cpdCategoryAdd}>
                <Button className='large full'>
                  <Icon icon='add-large' /> Add CPD Category
                </Button>
              </LinkContainer>
            </Col>
          </Row>
          <Tabs id='admin-tabs'>
            <Tab eventKey='active categories' title='Active Categories'>
              <SortableTable rows={activeCpdCategoryRows} columns={cpdCategoryColumns} className='table--admin-cpd-category' />
            </Tab>
            <Tab eventKey='archived categories' title='Archived Categories'>
              <SortableTable rows={archivedCpdCategoryRows} columns={cpdCategoryColumns} className='table--admin-cpd-category' />
            </Tab>
          </Tabs>
          <Row className='xs-gutter'>
            <Col xs={12} md={9}>
              <h2><Icon icon='caddie-links-large-alt' />Industry CPD Categories</h2>
            </Col>
            <SortableTable rows={industryCpdCategoryRows} columns={industryCpdCategoryColumns} className='table--admin-industry-cpd-category' />
          </Row>
        </Grid>
      </section>
    </div >
  );

const mapStateToProps = (state) => ({
  cpdCategorys: state.cpdCategorys.cpdCategorys,
  industries: state.industry.industries,
  industryCpdCategory: state.admin.industryCpdCategory,
  isFetching: state.admin.isFetchingIndustryCpdCategory
})
const mapDispatchToProps = (dispatch) => ({
  updateCpdCategory: bindActionCreators(adminActions.admin.updateCpdCategory, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ cpdCategorys, industries, industryCpdCategory, isFetching }) => cpdCategorys.length === 0 || industries === 0 || industryCpdCategory.length === 0 || isFetching,
    renderComponent(Loading)
  ),
  withProps(
    ({ cpdCategorys, industryCpdCategory, industries: allIndustries, updateCpdCategory }) => ({
      cpdCategoryRows: fp.flow(
        fp.map(
          (aoa) => {
            const industries = fp.flow(
              fp.filter(
                ({ cpdCategoryId }) => cpdCategoryId === aoa.id
              ),
              fp.map(
                ({ industryId }) => fp.find(
                  (industry) => industry.id === industryId
                )(allIndustries)
              ),
            )(industryCpdCategory)
            const industryNames = fp.flow(
              fp.map(
                fp.get('name')
              ),
              fp.join(',')
            )(industries)
            const filteredIndustryCpdCategory = fp.flow(
              fp.filter(
                ({ cpdCategoryId }) => cpdCategoryId === aoa.id
              )
            )(industryCpdCategory)
            const handleCpdCategoryStatusUpdate = (aoa, status) => (e) => {
              e.preventDefault();
              e.stopPropagation();
              updateCpdCategory(aoa.id, {
                cpdCategory: {
                  ...aoa,
                  status
                },
                industryCpdCategory: filteredIndustryCpdCategory
              }, undefined, true)
            }

            return {
              ...aoa,
              industry: industryNames,
              legacy: aoa.legacy ? 'Legacy' : '',
              type: fp.flow(
                fp.filter(({ value }) => aoa.categoryType === value),
                fp.first
              )(cpdCategoryTypeWithLabel).label || '',
              edit: <div>
                <LinkContainer to={routes.adminPortal.cpdCategoryEdit(aoa.id)}>
                  <Button bsStyle='plain'><Icon icon='edit-medium' />Edit</Button>
                </LinkContainer>
                {
                  !industryNames && aoa.status === CpdCategoryStatus.active ?
                    <Button className='warning' bsStyle='plain' onClick={
                      handleCpdCategoryStatusUpdate(aoa, CpdCategoryStatus.archived)
                    }>Archive</Button> : null
                }
                {
                  aoa.status === CpdCategoryStatus.archived ?
                    <Button className='left' bsStyle='plain' onClick={
                      handleCpdCategoryStatusUpdate(aoa, CpdCategoryStatus.active)
                    }>Activate</Button> : null
                }
              </div>
            }
          }
        ),
        fp.sortBy(
          row => row.name
        )
      )(cpdCategorys),
      industryCpdCategoryRows: fp.flow(
        fp.map(
          (industry) => {
            const parentCpdCategories = fp.flow(
              fp.filter(
                ({ industryId, parentCpdCategoryId }) => industryId === industry.id && !parentCpdCategoryId
              ),
              fp.map(
                ({ cpdCategoryId }) => {
                  const cpdCategory = fp.find(
                    ({ id }) => id === cpdCategoryId
                  )(cpdCategorys)
                  const children = fp.flow(
                    fp.filter(
                      child => industry.id === child.industryId && cpdCategory.id === child.parentCpdCategoryId
                    ),
                    fp.map(
                      child => fp.find(
                        ({ id }) => id === child.cpdCategoryId
                      )(cpdCategorys)
                    )
                  )(industryCpdCategory)
                  return {
                    ...cpdCategory,
                    children
                  }
                }
              )
            )(industryCpdCategory)
            const cpdCategories = <ul>
              {
                fp.flow(
                  fp.sortBy(
                    parent => parent.name
                  ),
                  fp.map(
                    ({ name, children }) => <li key={name}>
                      {name}
                      <ul>
                        {
                          fp.flow(
                            fp.sortBy(
                              child => child.name
                            ),
                            fp.map(
                              child => <li key={child.name}>{child.name}</li>
                            )
                          )(children)
                        }
                      </ul>
                    </li>
                  )
                )(parentCpdCategories)
              }
            </ul>
            return {
              ...industry,
              cpdCategories
            }
          }
        ),
        fp.sortBy(
          row => row.name
        )
      )(allIndustries)
    })
  ),
  withProps(
    ({ cpdCategoryRows }) => ({
      activeCpdCategoryRows: fp.filter(
        ({ status }) => status === CpdCategoryStatus.active
      )(cpdCategoryRows),
      archivedCpdCategoryRows: fp.filter(
        ({ status }) => status === CpdCategoryStatus.archived
      )(cpdCategoryRows)
    })
  )
)(AdminCpdCategory);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/cpd-category-portal/cpd-category.js